import React from 'react';

export const Header = () => {
	return (
		<div>
			<h1 class='header'>John Conway's Game of Life</h1>
		</div>
	);
};
